import { Injectable, Inject } from '@angular/core';


import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { DatosSesionService } from './datos-sesion.service';
import { environment } from '../../../environments/environment';
import { AplicativoUsuarioDTO } from '../modelado/dto/aplicativo-usuario-DTO';
import { ApiResponse } from '../../compartido/modelado-compartido/api-response';
import { DOCUMENT } from '@angular/platform-browser';
import {DatoGoogleDTO} from '../modelado/dto/dato-google-DTO';
//import { environment } from '../../../environments/environment';

@Injectable()
export class UsuarioSessionService {

  //UsuarioSessionService
  datoGoogle: DatoGoogleDTO;

  idAplicativo = environment.APP_ID;
  //idAplicativo = '';

  ambiente = environment.envAmbiente;

  baseUrl = environment.envURL_ACTIVIDAD;

  constructor(private http: Http
    , private _datosSesionService: DatosSesionService
    ,@Inject(DOCUMENT) private document: any
  ) {

    // console.log('=============== UsuarioSessionService ============');
    this.datoGoogle={};
  }

  logout() {
    if (environment.envName!=='local') {
      localStorage.setItem('url_redireccion',environment.APP_URL+'#'+environment.APP_ID);
      window.location.href = environment.URL_LOGOUT;
    }
  }


  verificaLogeo() {
    this.verificaSesion();
    if(this._datosSesionService.getAplicativo().idAplicativo !== environment.APP_ID) {
      if (!this._datosSesionService.sessionGoogle()) {
        this.cargaDataLdap();
      } else {
        this.cargaDataGoogle();
      }
    }
  }

  cargaDataLdap() {
    let url = environment.URL_SAR + '/aplicativo/permiteIngresoLDAP';
    let us = {
      "toke": this._datosSesionService.getToken(),
      "email": this._datosSesionService.getCorreoUsuario(),
      "appId": environment.APP_ID
    };

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(url,
      JSON.stringify(us),
      options
    )
      .toPromise()
      .then((res) => {

        let apiResponse = res.json() as ApiResponse;
        let respuestaSar = apiResponse.objeto;
        // console.log(respuestaSar);

        if(respuestaSar && respuestaSar.token){
          this._datosSesionService.guardarDatosSesion(respuestaSar);
          return true;
        }else{
          ////console.log('no tiene token ');

          let mensaje: string;

          if(respuestaSar && respuestaSar.usuario){
            mensaje = 'El usuario:' + respuestaSar.usuario.nombre + ' no tiene permiso para acceder a este aplicativo.\nEste incidente sera reportado. Redireccionando al logout...';
            localStorage.clear();
          }
          else{
            mensaje = 'El usuario  no tiene permiso para acceder a este aplicativo.\nPor favor asegúrese de ingresar con su cuenta de correo institucional\nEste incidente sera reportado. Redireccionando al logout...';
            localStorage.clear();
          }


          alert(mensaje);
          localStorage.clear();
          // this.limpiar();
          if (environment.envName!=='local'){
            window.location.href = environment.URL_LOGOUT;
          }
          // return false;
        }


      }).catch((error) => {
        console.error('Ha ocurrido un error al Iniciar nuevo...', error);
        if (error.status === 0) {
          if (!localStorage.getItem('redireccion')) {
            localStorage.setItem('redireccion', 'primer intento');
            this.document.location.reload();
          }
        }
        return Promise.reject(error.message || error);
      });
  }

  cargaDataGoogle() {
    const url = environment.URL_SAR_INICIAR;
    //const url = environment.URL_SAR_INICIAR + this.idAplicativo;
    // console.log('carga informacion del aplicativo 1llamada -->' + url);

    if(this._datosSesionService.sessionGoogle()) {
      const sesion_google = this._datosSesionService.getDatoSessionGoogle();
      console.log(sesion_google);
      this.datoGoogle.appId=this.idAplicativo;
      this.datoGoogle.email=sesion_google.userEmail;
      this.datoGoogle.toke=sesion_google.googleToken;
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      return this.http.post(url,
        JSON.stringify(this.datoGoogle),
        options
      )
        .toPromise()
        .then((res) => {

          let apiResponse = res.json() as ApiResponse;
          let respuestaSar = apiResponse.objeto;
          // console.log(respuestaSar);

          if(respuestaSar && respuestaSar.token){
            this._datosSesionService.guardarDatosSesion(respuestaSar);
            return true;
          }else{
            ////console.log('no tiene token ');

            let mensaje: string;

            if(respuestaSar && respuestaSar.usuario){
              mensaje = 'El usuario:' + respuestaSar.usuario.nombre + ' no tiene permiso para acceder a este aplicativo.\nEste incidente sera reportado. Redireccionando al logout...';
              localStorage.clear();
            }
            else{
              mensaje = 'El usuario  no tiene permiso para acceder a este aplicativo.\nPor favor asegúrese de ingresar con su cuenta de correo institucional\nEste incidente sera reportado. Redireccionando al logout...';
              localStorage.clear();
            }


            alert(mensaje);
            localStorage.clear();
            // this.limpiar();
            if (environment.envName!=='local'){
              window.location.href = environment.URL_LOGOUT;
            }
            // return false;
          }


        }).catch((error) => {
          console.error('Ha ocurrido un error al Iniciar nuevo...', error);
          if (error.status === 0) {
            if (!localStorage.getItem('redireccion')) {
              localStorage.setItem('redireccion', 'primer intento');
              this.document.location.reload();
            }
          }
          return Promise.reject(error.message || error);
        });
    }
  }




  verificaSesion() {
    if (this.ambiente === 'prod' || this.ambiente === 'des') {
      console.log('entra en segundo if actividadSesionRedis');
      const data = JSON.parse(localStorage.getItem('data'));
      if (data) {
        const sessionId = localStorage.getItem('sesion_id');
        if (sessionId) {
          const sesion = {
            token: sessionId,
            uid: data.usuario.correo,
            validez: 0
          };
          this.http.post(this.baseUrl, sesion)
            .toPromise().then((result) => {
            //si el estado es 200
            if (result.text() === 'true') {
              const a = true;
            } else {
              this.logout();
            }
          }, (err) => {
            //en caso de error
            const a = false;
          });
        } else {
          this.logout();
        }

      }
    }
  }

  /**
   * Carga el primer ves que ingresa al aplicativo, no usa el cutom http
   */
  cargaInformacionLogeo() {
    // console.log('ingresa UsuarioSessionService a datos session');
    //localStorage.setItem('valor','0');

    if (this._datosSesionService.existenDatos()){
      // console.log('SI existen datos');
      this.verificaLogeo();
      if(environment.envName==='des'){
        console.log('localStorage.setItem(\'data\',\''+localStorage.getItem('data')+'\');');
      }

      return true;
    }

    if ( !this._datosSesionService.sessionGoogle() )  {
      this.logout();
      //console.log('ir a login');
    }

    this.cargaDataGoogle();

  }



}
